import { gql } from '@apollo/client';
import React from 'react';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import ProjectTable from '../../components/projectTable';
import '../../../assets/scss/projectTable.scss';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import _ from 'lodash';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { async } from 'q';
const getEmployeeDefaultfilters = gql`
	query EmployeeDefaultfilters {
		employeeDefaultfilters {
			designation
			department
			workspaceId
		}
	}
`;
const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;
const getEmployeeList = gql`
	query Employees($filter: employeeListInput) {
		employees(filter: $filter) {
			data {
				fullName

				officePhoneNumber
				officeEmail
				personalPhoneNumber
				personalEmail
				workspaceId

				department
				branch {
					branchId
				}
				status
				employeeType
				designation
				id
				dp_b2_300w_key
				dp_signed_url
				tenantUserId
			}
			hasNextPage
			hasPrevPage
			limit
			nextPage
			prevPage
			totalDocs
			totalPages
			currentPage
		}
	}
`;
class HrEmployeeModule extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			employeeList: [],
			brandFilters: [],
			searchValue: '',

			statusFilters: [
				{ key: 'ACTIVE', name: 'Active' },
				{ key: 'TERMINATED', name: 'Terminated' },
				{ key: 'ON_HOLD', name: 'On Hold' },
			],
			columns: [
				// { title: 'FLAG' },
				// { title: 'Picture' },
				// { title: 'Image' },
				{ title: 'Candidate Name', cnColumn: true },
				{ title: 'Office Phone Number & Email' },
				{ title: 'Personal Phone Number & Email' },
				{ title: 'Department' },
				{ title: 'Brand' },
				{ title: 'Branch' },
				{ title: 'Type' },
				{ title: 'Status' },
			],
			limit: 30,
			totalPages: 1,
			departmentsFilters: [],
			barnchesFilters: [],
			currentViewPage: 1,
			isEmployeeLoading: true,
			departmentActiveFilter: [],
			brandActiveFilter: [],
			branchActiveFilter: [],
			statusActiveFilter: [],

			// //change it to true after getting te harddrives list from the API
			// isLoading: true,
			// isVendorUsersLoading: true,
			// hardDrivesList: [],
			// hardDrivesSummary: [],
			// limit: 20,
			// sortBy: '',
			// sortType: 0,
			// page: 1,
			// toggleColor: false,
			// currentViewPage: 1,
			// tenantUserList: [],
			// isPageLoading: false,
			// vendorUsers: [],
			// categoryActiveFilter: '',
			// searchWordFound: false,
			// searchValue: '',
			// branchIdsFilters: [],
			// branchIdsActiveFilter: [],
			// workspacesFilters: [],
			// workspaceActiveFilter: '',
			// assignedToFilters: [],
			// assignedToActiveFilter: '',
			// officeclk2: false,
			// outstationtclk2: false,
			// userclk2: false,
			// clientclk2: false,
			// workingclk2: false,
			// backupclk2: false,
			// secureclk2: false,
			// clientSearchFilter: '',
			// locationsActiveFilter: '',
			// locationsFilters: [
			// 	{ key: 'inOffice', name: 'In Office' },
			// 	{ key: 'client', name: 'Client' },
			// 	{ key: 'employee', name: 'Employee' },
			// 	{
			// 		key: 'outStation',
			// 		name: 'Outstation',
			// 	},
			// ],
			// categoryFilters: [
			// 	{ key: 'working', name: 'Working' },
			// 	{ key: 'backup', name: 'Backup' },
			// 	{ key: 'secured', name: 'Secure' },
			// ],
			// columns: [
			// 	// { title: 'FLAG' },
			// 	{ title: 'Qr Code' },
			// 	{ title: 'Projects' },
			// 	{ title: 'Type' },
			// 	{ title: 'Size' },
			// 	{ title: 'Location' },
			// 	{ title: 'Branch' },
			// 	// { title: 'Branch' },
			// 	{ title: 'Assigned To' },
			// 	{ title: 'Last Update By' },
			// 	// { title: 'Sourced By' },
			// ],
			// assignedToFilters: [],
			isPageLoading: true,
		};
	}

	componentDidMount = () => {
		let json = {};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];
		if (_.size(urlSearch) > 0) {
			let count = 0;

			let tempUrlSearch = _.cloneDeep(urlSearch);

			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');

				if (subString[0] && (subString[0] === 'page' || subString[0] === 'limit')) {
					json = {
						filter: {
							...json.filter,

							[subString[0]]: parseInt(subString[1]),
						},
					};
				}
				if (subString[0] && subString[0] === 'searchedQuery') {
					json = {
						filter: {
							...json.filter,

							name: subString[1],
						},
					};
				}
				if (
					(subString[0] && subString[0] === 'department') ||
					(subString[0] && subString[0] === 'branch') ||
					(subString[0] && subString[0] === 'status')
				) {
					json = {
						filter: {
							...json.filter,

							[subString[0]]: subString[1].split(','),
						},
					};
				}
				if (subString[0] && subString[0] === 'brand') {
					json = {
						filter: {
							...json.filter,

							workspaceId: subString[1].split(','),
						},
					};
				}
				if (subString[0] === 'limit') {
					this.setState({
						[subString[0]]: parseInt(subString[1]),
					});
				}
				if (subString[0] === 'searchedQuery') {
					this.setState({
						searchValue: subString[1],
					});
				}

				if (subString[0] === 'page') {
					this.setState({
						currentViewPage: parseInt(subString[1]),
					});
				}
				if (
					subString[0] === 'department' ||
					subString[0] === 'brand' ||
					subString[0] === 'branch' ||
					subString[0] === 'status'
				) {
					this.setState({
						[`${subString[0]}ActiveFilter`]: subString[1].split(','),
					});
				}
				count++;
			}
		} else {
			json = {
				filter: {
					limit: this.state.limit,
					page: this.state.currentViewPage,
				},
			};
		}
		// await this.getEmployeeList(getEmployeeList, json);
		// let json = {
		// 	filter: {
		// 		limit: this.state.limit,
		// 		page: this.state.currentViewPage,
		// 	},
		// };

		this.getEmployeeList(getEmployeeList, json);
		this.getEmployeeDefaultfilters(getEmployeeDefaultfilters);
		this.getBranchList2(getBranchList);
	};
	// handleActiveFilter = async (e, type, key) => {
	// 	let array;
	// 	// console.log('daf', this.state.departmentActiveFilter);
	// 	if (type === 'department') {
	// 		array = [...this.state[`${type}ActiveFilter`]];

	// 		if (array.includes(key) == false) {
	// 			array.push(key);
	// 		} else {
	// 			const index = array.indexOf(key);
	// 			if (index > -1) {
	// 				array.splice(index, 1); // 2nd parameter means remove one item only
	// 			}
	// 		}
	// 	}
	// 	this.setState(
	// 		{
	// 			[`${type}ActiveFilter`]: array,
	// 			currentViewPage: 1,
	// 			isPageLoading: true,
	// 		},
	// 		() => {
	// 			this.fetchMoreEmployees();
	// 			// let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`

	// 			// if (_.size(this.state.workspaceActiveFilter) > 0)
	// 			// queryString = `${queryString}&tenantIds=${this.state.workspaceActiveFilter.toString()}`;
	// 			// this.props.navigate(`/${this.props.params.vendorID}/projects${queryString}`);
	// 		},
	// 	);
	// 	// console.log('daf', this.state.departmentActiveFilter);
	// };
	handleActiveFilter = (e, type, key) => {
		let array;
		// if (type === 'department') {
		array = [...this.state[`${type}ActiveFilter`]];
		if (array.includes(key)) {
			// Remove the selected filter
			array = array.filter((item) => item !== key);
		} else {
			// Add the selected filter
			array.push(key);
		}
		// }
		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => {
				this.fetchMoreEmployees();
			},
		);
	};

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreEmployees();
				},
			);
		}
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreEmployees();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreEmployees();
				},
			);
		}
	};
	handleSearch = (e) => {
		this.setState(
			{
				searchValue: e.target.value,
			},
			() => {
				this.fetchMoreEmployees();
				// let value = e.target.value.toLowerCase()
				// let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`
				// if (_.size(value) > 0)
				//     queryString = `${queryString}&searchedQuery=${value}`
				// this.props.navigate(
				//     `/${this.props.params.vendorID}/projects${queryString}`
				// )
			},
		);

		// let result = [];
		// result = this.state.allDataProjectsList.filter((data) => {
		// return data.title.toLowerCase().search(value) != -1;
		// // return data.title.includes(value);
		// });
		// let searchFilters = {
		//     filters:{
		//         limit:this.state.searchLim,
		//         page:this.state.searchPage,
		//     }
		// }
		//  this.getSearchedProjectsList(getSearchedDataProjects,searchFilters)
		// if(result.length>0){
		//     this.setState({
		//         totalPages:1,
		//         limit:result.length,
		//         currentViewPage:this.state.searchPage,
		//         lengthOfList:result.length,
		//         projectsList:result,
		//         searchValue:value

		//     },
		// 	// () => this.fetchMoreProjects(),
		//     )
		//     // this.setState({
		//     //     projectsList:result
		//     // })
		// }
		// else if(result.length===0){
		//     this.setState({
		//         projectsList:{}
		//     })
		// }
	};
	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: [],
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => this.fetchMoreEmployees(),
		);
	};
	applyFilter = (filter, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				employeeList: [],
				isPageLoading: true,
			},
			() => {
				this.fetchMoreEmployees();
			},
		);
	};
	fetchMoreEmployees = async () => {
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;
		if (this.state.searchValue !== '')
			queryString = `${queryString}&searchedQuery=${this.state.searchValue.toString()}`;
		if (_.size(this.state.departmentActiveFilter) > 0)
			queryString = `${queryString}&department=${this.state.departmentActiveFilter.toString()}`;
		if (_.size(this.state.brandActiveFilter) > 0)
			queryString = `${queryString}&brand=${this.state.brandActiveFilter.toString()}`;
		if (_.size(this.state.branchActiveFilter) > 0)
			queryString = `${queryString}&branch=${this.state.branchActiveFilter.toString()}`;
		if (_.size(this.state.statusActiveFilter) > 0)
			queryString = `${queryString}&status=${this.state.statusActiveFilter.toString()}`;

		this.props.navigate(`/${this.props.params.vendorID}/hr${queryString}`);

		let filters = {
			filter: {
				limit: this.state.limit,
				page: this.state.currentViewPage,
			},
		};
		if (this.state.searchValue !== '') {
			filters = {
				filter: {
					...filters.filter,
					name: this.state.searchValue,
				},
			};
		}
		// if (this.state.departmentActiveFilter !== []) {
		console.log(this.state.departmentActiveFilter.length);
		if (this.state.departmentActiveFilter.length > 0) {
			// filters.filter.page = 1;
			filters.filter.department = this.state.departmentActiveFilter;
		}
		if (this.state.brandActiveFilter.length > 0) {
			// filters.filter.page = 1;
			filters.filter.workspaceId = this.state.brandActiveFilter;
		}
		if (this.state.branchActiveFilter.length > 0) {
			// filters.filter.page = 1;
			filters.filter.branch = this.state.branchActiveFilter;
		}
		if (this.state.statusActiveFilter.length > 0) {
			// filters.filter.page = 1;
			filters.filter.status = this.state.statusActiveFilter;
		}
		// }
		this.setState({
			isEmployeeLoading: true,
		});

		this.getEmployeeList(getEmployeeList, filters);
	};
	render() {
		// console.log(this.state.barnchesFilters);
		// console.log(this.state.brandFilters);

		// console.log(this.state.departmentActiveFilter);
		// console.log('employeelist', this.state.employeeList);
		return (
			<div>
				<div className="layout-wrapper">
					{this.state.isEmployeeLoading ? (
						<>
							<LoadingBar />
						</>
					) : (
						<div className="container">
							<div className="searchContainer">
								{/* <div
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '12px',
									}}
									className="shoots-header-filters-container"
								> */}
								<div className="title shoots-header-filters-container">
									<a
										className=""
										style={{
											color: '#DBDBDB',
											fontSize: '16px',
											fontWeight: '600',
										}}
									>
										Hr
									</a>

									<Filter
										type={'department'}
										label={'Department'}
										version="v2"
										applyFilter={this.applyFilter}
										filters={this.state.departmentsFilters}
										activeFilter={this.state.departmentActiveFilter}
										// handleActiveFilter={(e, status, key) => {
										// 	console.log('handle active filter clicked');
										// 	this.handleActiveFilter(e, 'department', key);
										// }}
										clearSelection={(e) =>
											this.handleclearSelection(e, 'department')
										}
										isMultipleSelectable={true}
										filterType="shoot"
										// applyFilter={this.applyFilter}
									/>
									<Filter
										type={'brand'}
										label={'Brand'}
										version="v2"
										filters={this.state.brandFilters}
										activeFilter={this.state.brandActiveFilter}
										handleActiveFilter={(e, status, key) =>
											this.handleActiveFilter(e, 'brand', key)
										}
										clearSelection={(e) =>
											this.handleclearSelection(e, 'brand')
										}
										isMultipleSelectable={true}
										filterType="shoot"
										applyFilter={this.applyFilter}
									/>
									<Filter
										type={'branch'}
										label={'Branch'}
										version="v2"
										filters={this.state.barnchesFilters}
										activeFilter={this.state.branchActiveFilter}
										handleActiveFilter={(e, status, key) =>
											this.handleActiveFilter(e, 'branch', key)
										}
										clearSelection={(e) =>
											this.handleclearSelection(e, 'branch')
										}
										isMultipleSelectable={true}
										filterType="shoot"
										applyFilter={this.applyFilter}
									/>
									<Filter
										type={'status'}
										label={'Status'}
										version="v2"
										filters={this.state.statusFilters}
										activeFilter={this.state.statusActiveFilter}
										handleActiveFilter={(e, status, key) =>
											this.handleActiveFilter(e, 'status', key)
										}
										clearSelection={(e) =>
											this.handleclearSelection(e, 'status')
										}
										isMultipleSelectable={true}
										filterType="shoot"
										applyFilter={this.applyFilter}
									/>
								</div>
								{/* </div> */}

								<div
									className="searchWrapper"
									style={
										{
											// paddingLeft: '100px',
										}
									}
								>
									<div className="search-inner-left">
										<span className="search-icon">
											<SearchIcon />
										</span>
										<input
											placeholder="Search User"
											// name={this.state.searchType}
											value={this.state.searchValue}
											onChange={
												(event) => {
													this.setState({
														searchValue: event.target.value,
													});
												}
												// this.setState({
												// 	searchValue: event.target.value,
												// })
												// this.handleSearch(event)
											}
										/>
									</div>
									<div
										className="search-inner-right"
										onClick={() => this.fetchMoreEmployees()}
									>
										<span
											className="search-dropdown-btn"
											style={{ position: 'relative' }}
										>
											<a className="search-type">
												{/* <b
                                                    className={
                                                        this.state
                                                            .showSearchDropDown
                                                            ? 'invert'
                                                            : ''
                                                    }
                                                > */}
												<p
													style={{
														paddingRight: '20px',
													}}
													// onClick={
													//     this
													//         .handleSearchClick
													// }
												>
													Search
												</p>
												{/* </b> */}
											</a>
										</span>
									</div>
								</div>
								<div
									className="create-shoot-btn"
									onClick={() =>
										// /:vendorID/hr/add-employee
										this.props.navigate(
											`/${this.props.params.vendorID}/hr/add-employee`,
										)
									}
								>
									+ Add member
								</div>
							</div>
							{/* <div className={'table project-table-list'}> */}
							<div className={'table tenant-users-table'}>
								<ProjectTable
									// ptProps="yes"
									tableHeaderLeftPad={35}
									isLoading={this.state.isLoading}
									tableHeader={`SHOOTS`}
									columns={this.state.columns}
									// activeSortType={this.state.sortType}
									// activeSortBy={this.state.sortBy}
									// handleSort={this.handleProjectSort}
									// isPageLoading={this.state.isPageLoading}
									limit={this.state.limit}
									totalPages={this.state.totalPages}
									currentViewPage={this.state.currentViewPage}
									lengthOfList={this.state.lengthOfList}
									onClickNextPage={this.onClickNextPage}
									onClickPreviousPage={this.onClickPreviousPage}
									dataList={this.state.employeeList}
									goToPage={(e) => this.handleGoToPage(e)}
									// module={'project'}
									searchQuery={''}
									module={'project'}
									mainFilter={''}
								>
									{this.state.employeeList.length > 0 &&
										this.state.employeeList
											// .filter((el) => {
											// 	if (this.state.searchValue === '') {
											// 		return el;
											// 	} else if (
											// 		el.fullName
											// 			.toLowerCase()
											// 			.includes(
											// 				this.state.searchValue.toLowerCase(),
											// 			)
											// 	) {
											// 		return el;
											// 	}
											// })
											.map((emp) => {
												return (
													<tr
														onClick={() => {
															// /:vendorID/hr/:employeeId
															this.props.navigate(
																`/${this.props.params.vendorID}/hr/${emp.id}`,
															);
														}}
													>
														{/* <td
															style={{
																padding: '0px',
															}}
														>
															{emp.dp_b2_300w_key ? (
																<img
																	style={{
																		height: '54px',
																		width: '54px',
																	}}
																	src={`https://display.cragy.in/${emp.dp_b2_300w_key}`}
																	alt=""
																/>
															) : (
																''
															)}
														</td> */}
														<td
															style={{
																color: '#E4E5E6',
																fontSize: '13px',
															}}
														>
															<div
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	gap: '8px',
																}}
															>
																{emp.dp_signed_url ? (
																	<img
																		style={{
																			height: '31.06px',
																			width: '31.06px',
																			borderRadius: '50%',
																		}}
																		src={emp.dp_signed_url} //{`https://display.cragy.in/${emp.dp_b2_300w_key}`}
																		alt=""
																	/>
																) : (
																	<div
																		style={{
																			height: '31.06px',
																			width: '31.06px',
																			minHeight: '31.06px',
																			minWidth: '31.06px',
																			borderRadius: '50%',
																			backgroundColor:
																				'#898989',
																		}}
																	></div>
																)}
																<div
																	style={{
																		display: 'flex',
																		flexDirection: 'column',
																		gap: '5px',
																	}}
																>
																	<p>
																		{emp.fullName
																			? emp.fullName
																					.split(' ')
																					.map(
																						(word) =>
																							word
																								.charAt(
																									0,
																								)
																								.toUpperCase() +
																							word
																								.slice(
																									1,
																								)
																								.toLowerCase(),
																					)
																					.join(' ')
																			: ''}
																	</p>
																	<p
																		style={{
																			color: '#707070',
																		}}
																	>
																		{/* {emp.designation} */}
																		{emp.designation
																			? emp.designation
																					.charAt(0)
																					.toUpperCase() ===
																			  emp.designation.charAt(
																					0,
																			  )
																				? emp.designation
																				: emp.designation
																						.charAt(0)
																						.toUpperCase() +
																				  emp.designation
																						.replace(
																							/([A-Z])/g,
																							' $1',
																						)
																						.slice(1)
																			: ''}
																	</p>
																</div>
															</div>
														</td>
														<td
															style={{
																color: '#E4E5E6',
																fontSize: '13px',
															}}
														>
															<div
																style={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																}}
															>
																<p>
																	{emp.officePhoneNumber?.slice(
																		3,
																	)}
																</p>
																<p
																	style={{
																		color: '#707070',
																	}}
																>
																	{/* {emp.designation} */}
																	{emp.officeEmail}
																</p>
															</div>
															{/* {emp.officePhoneNumber} */}
														</td>
														<td
															style={{
																color: '#E4E5E6',
																fontSize: '13px',
															}}
														>
															<div
																style={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '5px',
																}}
															>
																<p>
																	{emp.personalPhoneNumber.slice(
																		3,
																	)}
																</p>
																<p
																	style={{
																		color: '#707070',
																	}}
																>
																	{/* {emp.designation} */}
																	{emp.personalEmail}
																</p>
															</div>
														</td>
														<td
															style={{
																color: '#E4E5E6',
																fontSize: '13px',
																textTransform: 'capitalize',
															}}
														>
															{emp.department}
														</td>
														<td
															style={{
																color: '#E4E5E6',
																fontSize: '13px',
															}}
														>
															{/* {emp.workspaceId} */}
															{emp.workspaceId
																? emp.workspaceId
																		.charAt(0)
																		.toUpperCase() ===
																  emp.workspaceId.charAt(0)
																	? emp.workspaceId
																	: emp.workspaceId
																			.charAt(0)
																			.toUpperCase() +
																	  emp.workspaceId
																			.replace(
																				/([A-Z])/g,
																				' $1',
																			)
																			.slice(1)
																: ''}
														</td>
														<td
															style={{
																color: '#E4E5E6',
																fontSize: '13px',
															}}
														>
															{emp.branch ? emp.branch.branchId : ''}
														</td>
														<td
															style={{
																color: '#E4E5E6',
																fontSize: '13px',
															}}
														>
															{emp.employeeType}
														</td>
														<td
															style={{
																color: '#E4E5E6',
																fontSize: '13px',
															}}
														>
															{/* {emp.status} */}
															<span
																className={`completed-shoots `}
																style={{
																	// marginTop: '-120px',

																	display: 'flex',
																	// justifyContent: 'flex-start',
																	alignItems: 'center',
																	textTransform: 'uppercase',
																	fontSize: '14px',
																}}
															>
																<b
																	style={{
																		width: '6px',
																		height: '6px',
																		minHeight: '6px',
																		minWidth: '6px',
																		borderRadius: '50%',
																		backgroundColor:
																			emp.status === 'ACTIVE'
																				? '#49B217'
																				: emp.status ===
																				  'TERMINATED'
																				? '#707070'
																				: '#E46E00',
																		marginRight: 5,
																		display: 'flex',
																	}}
																></b>
																{emp.status}
																{/* <p>{this.props.data.status}</p> */}
															</span>
														</td>
													</tr>
												);
											})}
								</ProjectTable>
								{this.state.employeeList.length == 0 && (
									<span style={{ color: 'white' }}>No Employees are found!</span>
								)}
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}
export default withRouter(HrEmployeeModule);
